import { BriefingDateRangeApiModel } from '../../../api/briefings/model/briefing-date-range-api.model';
import moment from 'moment-timezone';
import 'moment-timezone';
import { TimeHelper } from '../../../Common/Forms/helpers/time.helper';

export class BriefingDateRangeModel {
    start: Date;
    end: Date;

    constructor(apiModel?: BriefingDateRangeApiModel, timezone?: string) {
        if (apiModel) {
            this.start = apiModel.start ? new Date(TimeHelper.convertTo13DigitTimestamp(apiModel.start)) : null;
            this.end = apiModel.end ? new Date(TimeHelper.convertTo13DigitTimestamp(apiModel.end)) : null;

            if (timezone) {
                // translate from utc
                if (this.start) {
                    this.start = moment.utc(this.start).tz(timezone).toDate();
                }
                if (this.end) {
                    this.end = moment.utc(this.end).tz(timezone).toDate();
                }
            }
        } else {
            this.start = null;
            this.end = null;
        }
    }

    /**
     * Converts this time range to an api time range.
     * Optionally a timezone can be included to correct the offset to UTC
     */
    toBriefingDateRangeApiModel(timezone?: string): BriefingDateRangeApiModel {
        const apiModel = {
            start: this.start ? +this.start : null,
            end: this.end ? +this.end : null
        };
        if (timezone) {
            // translate to utc
            if (apiModel.start) {
                apiModel.start = +moment(apiModel.start, timezone).utc();
            }
            if (apiModel.end) {
                apiModel.end = +moment(apiModel.end, timezone).utc();
            }
        }

        if (apiModel.start) {
            apiModel.start = Math.round(apiModel.start / 1000);
        }
        if (apiModel.end) {
            apiModel.end = Math.round(apiModel.end / 1000);
        }
        return apiModel;
    }

    /**
     * Compares this time range against another to verify they are the same
     */
    equals(other: BriefingDateRangeModel): boolean {
        if (+this.start !== +new Date(other.start)) {
            return false;
        }
        if (+this.end !== +new Date(other.end)) {
            return false;
        }
        return true;
    }
}
